export function getQuizData(quizId) {
    return window.growtype_quiz_data[quizId];
}
